'use strict';

angular.module('app').directive('paymentTerms', function ($http, $compile, utils) {
  return {
    restrict: 'AE',
    scope: {
      paymentTerms: '=',
      title: '@',
    },
    replace: true,
    template: '<div class="payment-terms">' +
            '<a class="payment-terms-btn">{{title || "Payment terms & cancellation policy"}}</a>' +
            '</div>',
    link: function (scope) {
      scope.onlyDiveProducts = scope.paymentTerms.onlyDP;

      $('.payment-terms-btn').click(function () {
        scope.cancellationFree = moment(new Date()).add(2, 'days').format();
        
        scope.getMilestoneAmountType = getMilestoneAmountType;

        function getMilestoneAmountType(amountTypeKey) {
          return utils.getTextFromInfo(amountTypeKey, 'shop', 'MILESTONE_AMOUNT_TYPE') || scope.paymentTerms.currency;
        }

        $http.get('/templates/_payment-popup.html?v2').then(function (response) {
          if (response.status === 200) {
            var template = $compile(angular.element(response.data))(scope);
            // generateText();
            $.fancybox({
              content: template,
              type: 'html',
              minWidth: '200px',
              maxWidth: '750px',
              padding: 40,
              wrapCSS: 'form-popup cancellation',
              autoDimensions: false,
            });
          }
        });
      });
    },
  };
});
